//angular
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
//app modules
import { AdvancedSettingsRoutingModule } from './advanced-settings.routing';
import { AppMaterialModule } from 'src/app/app.material';
import { AppSharedModule } from 'src/app/_shared/app.shared.module';
import { SharedModule } from '../../_shared/shared.module';
//app services
import { AuthGuardService } from 'src/app/_guard/auth.guard';
//app dialogs
import { DialogChangeBillingRuntimeComponent } from './billing-operations/dialog-charge-billing-runtime/dialog-charge-billing-runtime.component';
import { DialogChangePaymentRuntimeComponent } from './payment-operations/dialog-charge-payment-runtime/dialog-charge-payment-runtime.component';
import { NewNotificationsComponent } from './notifications/new-notifications/new-notifications.component';
//app components
import { ApiCredentialsComponent } from './api-credentials/api-credentials.component';
import { ApiCredentialsCreateComponent } from './api-credentials/create-api-credentials/create-api-credentials.component';
import { BillingOperationsComponent } from './billing-operations/billing-operations.component';
import { BillingOperationDetailComponent } from './billing-operations-detail/billing-operations-detail.component';
import { DialogNewNotificationsComponent } from './notifications/new-notifications/dialog-new-notifications/dialog-new-notifications.component';
import { DunningAutomaticConfigComponent } from '../advanced-settings/dunning/automatic-payments-config/automatic-payments-config.component';
import { DunningManagementComponent } from '../advanced-settings/dunning/dunning-management/dunning-management.component';
import { DunningManualConfigComponent } from '../advanced-settings/dunning/manual-payments-config/manual-payments-config.component';
import { EventDetailComponent } from './logs/manage/event-detail.component';
import { EventsComponent } from './logs/list/events.component';
import { GridBillRunComponent } from './billing-operations/grid-bill-run/grid-bill-run.component';
import { GridBillRunHistoryComponent } from './billing-operations/grid-bill-run-history/grid-bill-run-history.component';
import { GridPaymentRunComponent } from './payment-operations/grid-payment-run/grid-payment-run.component';
import { GridPaymentRunHistoryComponent } from './payment-operations/grid-payment-run-history/grid-payment-run-history.component';
import { InboxComponent } from './notifications/inbox/inbox.component';
import { LayoutAdvancedSettingsComponent } from './layout/layout.component';
import { ManageNotificationsComponent } from './notifications/manage/manage-notifications.component';
import { NotificationsComponent } from './notifications/list/notifications.component';
import { PaymentOperationsComponent } from './payment-operations/payment-operations.component';
import { PaymentOperationsDetailComponent } from './payment-operations-detail/payment-operations-detail.component';
import { SecurityComponent } from './security/security.component';
import { SmtpSettingComponent } from './notifications/smpt-setting/smpt-setting.component';
import { TemplatesComponent } from './notifications/templates/templates.component';
import { TemplateEditorComponent } from './notifications/template-editor/template-editor.component';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { RebNgxMatButtonModule, RebNgxMatDatePickerModule } from '@rhinosaas/reb-ngx';
import { RebNgxMatMenuModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-menu';
import { RebNgxMatMenuButtonItemModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-menu-button-item';
import { RebNgxMatTabsModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-tabs';
import { RebNgxMatTabItemModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-tab-item';
import { RebNgxMatTabNavBarModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-tab-nav-bar';
import { SendTestDialogComponent } from './notifications/manage/send-test-dialog/send-test-dialog.component';
import { NotificationItemComponent } from './notifications/list/notification-item/notification-item.component';
import { NewWebhookComponent } from './api-credentials/new-webhook/new-webhook.component';
import { RecentEventsComponent } from './api-credentials/new-webhook/recent-events/recent-events.component';
import { RecentEventsDetailComponent } from './api-credentials/new-webhook/recent-events-detail/recent-events-detail.component';

const COMPONENTS: any[] = [
  ApiCredentialsComponent,
  ApiCredentialsCreateComponent,
  BillingOperationsComponent,
  BillingOperationDetailComponent,
  DialogChangeBillingRuntimeComponent,
  DialogChangePaymentRuntimeComponent,
  DunningAutomaticConfigComponent,
  DunningManagementComponent,
  DunningManualConfigComponent,
  GridBillRunComponent,
  GridBillRunHistoryComponent,
  GridPaymentRunComponent,
  GridPaymentRunHistoryComponent,
  InboxComponent,
  ManageNotificationsComponent,
  TemplatesComponent,
  EventsComponent,
  EventDetailComponent,
  LayoutAdvancedSettingsComponent,
  NewNotificationsComponent,
  NotificationsComponent,
  PaymentOperationsComponent,
  PaymentOperationsDetailComponent,
  SecurityComponent,
  SmtpSettingComponent,
  TemplateEditorComponent,
  SendTestDialogComponent
]

const DIALOGS: any[] = [
  DialogNewNotificationsComponent,
]

const MODULES: any[] = [
  AdvancedSettingsRoutingModule,
  AppMaterialModule,
  AppSharedModule,
  CommonModule,
  FormsModule,
  NgxCleaveDirectiveModule,
  ReactiveFormsModule,
  SharedModule,
  RebNgxMatMenuModule,
  RebNgxMatMenuButtonItemModule,
  RebNgxMatButtonModule,
  RebNgxMatTabsModule,
  RebNgxMatTabItemModule,
  RebNgxMatTabNavBarModule,
  RebNgxMatDatePickerModule
]

const PROVIDERS: any[] =[
  AuthGuardService
]

@NgModule({
    declarations: [COMPONENTS, DIALOGS, NotificationItemComponent, NewWebhookComponent, RecentEventsComponent, RecentEventsDetailComponent],
    imports: [MODULES],
    providers: [PROVIDERS]
})

export class AdvancedSettingsModule {
  constructor() {
    console.log(`@advanced-settings.module.ts was loaded.`)
  }
}
